var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRazerSmClip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0,
    viewBox: "0 0 256 341",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "objectBoundingBox",
    id: "razerSmBorder",
    transform: "scale(0.00390625, 0.00293255)"
  }, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M0 30.7994C0 26.9458 2.92009 23.7193 6.75453 23.336L231.687 0.850741C236.102 0.409357 239.934 3.87673 239.934 8.31415V63.5518C239.934 65.8541 240.991 68.0289 242.802 69.4509L252.152 76.794C253.963 78.216 255.021 80.3908 255.021 82.6931V333.315C255.021 337.457 251.662 340.815 247.52 340.815H131.524C129.017 340.815 126.675 339.562 125.284 337.475L114.736 321.653C113.345 319.567 111.003 318.313 108.495 318.313H7.5006C3.35813 318.313 0 314.955 0 310.813V30.7994Z",
    fill: ""
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRazerSmClip);
export default __webpack_public_path__ + "static/media/razer-sm-clip.b59d2031.svg";
export { ForwardRef as ReactComponent };